import {isFeatureEnabled} from '@github-ui/feature-flags'
import {isUIService} from '@github-ui/runtime-environment'

/** Whether the React code-view header is active (always true in UI service, feature-flagged elsewhere). */
export function isReactCodeViewHeaderEnabled(): boolean {
  return isUIService || isFeatureEnabled('code_view_react_header')
}
